import React from "react";
import { match } from "ts-pattern";
import { default as Tick } from "../../../../public/assets/chat-tick.svg?react";
import { default as TwoTicks } from "../../../../public/assets/chat-two-ticks.svg?react";
import { ChatMessageTicksType } from "../utils/chatUtils";

interface Props {
  ticks: ChatMessageTicksType;
}

function ChatMessageTicks(props: Props) {
  return match(props.ticks)
    .with("sent", () => <Tick />)
    .with("delivered", () => <TwoTicks />)
    .with("read", () => <TwoTicks color="#3077EB" />)
    .exhaustive();
}

export default ChatMessageTicks;
